import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const CLEAR_DATA = "saga/CLEAR_DATA";
export const MAX_SELECTED = "saga/MAX_SELECTED";
export const DISPLAY_ERROR = "saga/DISPLAY_ERROR";
export const SET_CHART_LOADING = "saga/SET_CHART_LOADING";
export const UPDATE_CUSTOM_RANGE = "saga/UPDATE_CUSTOM_RANGE";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTER_DATA_SUCCESS = "saga/FETCH_FILTER_DATA_SUCCESS";
export const FETCH_OFFERS_DATA_SUCCESS = "saga/FETCH_OFFERS_DATA_SUCCESS";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_FILTERS_SUCCESS = "saga/UPDATE_FILTERS_SUCCESS";
export const FETCH_DATA_AND_FILTERS = "sagas/FETCH_DATA_AND_FILTERS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchDataAndFilters: createAction(FETCH_DATA_AND_FILTERS),
  updateDates: createAction(UPDATE_DATES),
  updateFilters: createAction(UPDATE_FILTERS),
  maxSelected: createAction(MAX_SELECTED),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};

export default function* watchChallengerConversion() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_DATA_AND_FILTERS, getDataAndFilters);
}

export function* getCurrentUserData(data) {
  yield put({ type: CLEAR_DATA, payload: true });

  let [id, objectId, locationId, regionId, calendarEndDate] = getCommonApiParams(data.payload.data);
  let endDate, startDate;

  if (data.payload.updateOnlyChart) yield updateOnlyChart(id, objectId, locationId, regionId);
  else {
    yield put({ type: SET_LOADING, payload: true });
    startDate = moment(calendarEndDate).startOf("month").format("YYYY-MM-DD");
    endDate = calendarEndDate;
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.data });
    yield put({ type: SET_DATES, payload: { startDate, endDate } });

    yield getFilterData(id, objectId, locationId, regionId, startDate, endDate);

    try {
      yield offersData(id, objectId, locationId, regionId, startDate, endDate);
      yield put({ type: SET_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  }
}

function getCommonApiParams(data) {
  let {
    organizationId: id,
    objectId,
    locationId,
    regionId,
    params: { calendarEndDate }
  } = data;
  return [id, objectId, locationId, regionId, calendarEndDate];
}

function* updateOnlyChart(id, objectId, locationId, regionId) {
  let { startDate, endDate } = yield select(
    (state) => state.challengerConversion.selectedRequestDates
  );

  yield offersData(id, objectId, locationId, regionId, startDate, endDate);
}

function* offersData(id, objectId, locationId, regionId, startDate, endDate) {
  yield put({ type: SET_CHART_LOADING, payload: true });
  let selectedFilters = yield select((state) => state.challengerConversion.selectedFilters);
  let allSagas = [];
  if (selectedFilters.length === 0) yield setError();
  else {
    for (let i = 0; i < selectedFilters.length; i++) {
      allSagas.push(
        getOffersData(id, objectId, locationId, regionId, startDate, endDate, selectedFilters[i].id)
      );
    }
    try {
      yield all(allSagas);
      yield put({ type: SET_CHART_LOADING, payload: false });
    } catch (error) {
      console.error(error);
    }
  }
}

function* setError() {
  yield put({
    type: DISPLAY_ERROR,
    payload: {
      haveError: true,
      errorText: "No data available for selected dates/offers. Please update filters and try again."
    }
  });
}

export function* getDataAndFilters(data) {
  let [id, objectId, locationId, regionId] = getCommonApiParams(data.payload.data);
  let { startDate, endDate } = yield select(
    (state) => state.challengerConversion.selectedRequestDates
  );

  yield getFilterData(id, objectId, locationId, regionId, startDate, endDate, true);
  try {
    yield put({ type: CLEAR_DATA, payload: true });
    yield offersData(id, objectId, locationId, regionId, startDate, endDate);
  } catch (error) {
    console.error(error);
  }
}

export function* getFilterData(
  id,
  objectId,
  locationId,
  regionId,
  startDate,
  endDate,
  usePrevSelectedFilters = false
) {
  const tableDataResponse = yield call(
    axios.get,
    queryParams.apiVersion +
      "pages/packages/challenger_conversion_chart/get_conversion_filters" +
      "?organization_id=" +
      id +
      "&location_id=" +
      locationId +
      "&object_id=" +
      objectId +
      "&region_id=" +
      regionId +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate
  );
  yield put({
    type: FETCH_FILTER_DATA_SUCCESS,
    payload: { data: tableDataResponse.data, usePrevSelectedFilters }
  });
}

export function* getOffersData(id, objectId, locationId, regionId, startDate, endDate, offerId) {
  try {
    const tableDataResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/packages/challenger_conversion_chart/get_challenger_conversion_values" +
        "?id=" +
        offerId +
        "&organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&object_id=" +
        objectId +
        "&region_id=" +
        regionId +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate
    );

    yield put({ type: FETCH_OFFERS_DATA_SUCCESS, payload: tableDataResponse.data });
  } catch (error) {
    console.error(error);
  }
}
